import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-not-found',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './not-found.component.html',
	styleUrls: ['./not-found.component.css'],
})
export class NotFoundComponent {
	canGoBack() {
		return window.history.length > 1;
	}

	goBack() {
		window.history.back();
	}
}
